module.exports = __webpack_public_path__ + "assets/e22cc8ccdafa0b227bb2593ace6d1f5b.png";